module.exports = __webpack_public_path__ + "img/left-top-txt.fb0bc3d8.png";